import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import TextField from '../../atoms/TextField/TextField'
import './LimitTextField.css'

const LimitTextField = ({
  index,
  limitLength,
  text,
  handleChange,
  showLimitCount,
  title,
  placeholder,
  type,
  errorMessage,
  disabled
}) => {
  return (
    <label>
      {title === null || title === '' ? null : (
        <div styleName="title">
          <p styleName="title__text">{title}</p>
        </div>
      )}
      <TextField
        idx={index}
        handleChange={handleChange}
        limitLength={limitLength}
        currentText={text}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
      />
      {showLimitCount ? (
        <p styleName="restTextLength">
          {text.length}/{limitLength}
        </p>
      ) : null}
      {errorMessage ? <p styleName="errorMessage">{errorMessage}</p> : null}
    </label>
  )
}

LimitTextField.propTypes = {
  index: PropTypes.number,
  limitLength: PropTypes.number,
  text: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  showLimitCount: PropTypes.bool.isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool
}

LimitTextField.defaultProps = {
  text: '',
  showLimitCount: true,
  placeholder: '',
  type: 'text',
  disabled: false
  // idx: 1
}

export default compose(pure)(LimitTextField)
